/** 根据字段类型返回拼接 sql 的具体指 */
import { SQLOperator } from '../_constants/field';
var sqlTypeMap = {
    string: ['varchar', 'char', 'text', 'mediumtext'],
    number: ['int', 'bigint']
};
var isStringType = function (type) {
    return sqlTypeMap.string.find(function (sqlType) {
        return sqlType === type || type.includes(sqlType);
    });
};
var isNumberType = function (type) {
    return sqlTypeMap.number.find(function (sqlType) {
        return sqlType === type || type.includes(sqlType);
    });
};
export var getValueByFieldType = function (dbType, val) {
    if (isStringType(dbType)) {
        return "'".concat(val, "'");
    }
    else if (isNumberType(dbType)) {
        return val;
    }
    return val;
    // switch (dbType) {
    // case 'varchar': return `'${val}'`;
    // case 'bigint': return val;
    // case 'mediumtext': return `'${val}'`;
    // default: return val;
    // }
};
/** 根据字段类型以及操作符号返回拼接 sql 的具体值 */
export var getValueByOperatorAndFieldType = function (dbType, operator, val) {
    if ([SQLOperator.LIKE, SQLOperator.NOT_LIKE].includes(operator)) {
        return "'%".concat(val, "%'");
    }
    else if ([SQLOperator.IN, SQLOperator.NOT_IN].includes(operator)) {
        return "(".concat((Array.isArray(val) ? val : String(val).split(',')).map(function (item) { return getValueByFieldType(dbType, item); }).join(','), ")");
    }
    else if ([SQLOperator.IS_NOT_NULL, SQLOperator.IS_NULL].includes(operator)) {
        return '';
    }
    return getValueByFieldType(dbType, val);
};
/** 根据字段类型获取 sql 拼接时字段值的符号 */
export var getQuoteByFieldType = function (dbType) {
    if (isStringType(dbType)) {
        return '\'';
    }
    else if (isNumberType(dbType)) {
        return '';
    }
    return '';
    // switch (dbType) {
    // case FieldDBType.VARCHAR: {
    // 	return '\'';
    // }
    // case FieldDBType.BIGINT: {
    // 	return '';
    // }
    // case FieldDBType.MEDIUMTEXT: {
    // 	return '\'';
    // }
    // default: return '';
    // }
};
